<template>
  <b-form>
    <slot v-if="show" />
    <div v-else>
      <b-button
        class="xl-wide"
        variant="outline-primary"
        @click="onAdd">
        <b-icon icon="plus-circle-fill" />
        Add
      </b-button>
    </div>
  </b-form>
</template>

<script>
  export default {
    name: 'OptionalForm',
    props: {
      show: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      onAdd() {
        this.$emit('add')
      },
    },
  }
</script>

<style>
</style>
